module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/google_classroom_green-e9a49.png";